export default {"src":"/newStatic/_next/static/media/poolSales_icon.30193448.svg","height":49,"width":48};